<template>
  <div>
      <div class="main">
        <div class="preview">
            <h3>プレビュー</h3>
        </div>
        <ul class="flex-containar-2">
            <li class="voice-state-2">
                <img class="img-2 color1" v-bind:style="{outlineColor: colors.hex8,boxShadow: '4px 4px 0px 0 ' + colors.hex8}" :src="imgPath">
                <div class="name-box-2">
                    <span class="name-2" v-bind:style="{background: colors.hex8}" >User1</span>
                </div>
            </li>
            <li class="voice-state-2">
                <img class="img-2 color2" v-bind:style="{outlineColor: colors.hex8,boxShadow: '4px 4px 0px 0 ' + colors.hex8}" :src="imgPath">
                <div class="name-box-2">
                    <span class="name-2" v-bind:style="{background: colors.hex8}">User2</span>
                </div>
            </li>
            <li class="voice-state-2">
                <img class="img-2 color3" v-bind:style="{outlineColor: colors.hex8,boxShadow: '4px 4px 0px 0 ' + colors.hex8}" :src="imgPath">
                <div class="name-box-2">
                    <span class="name-2" v-bind:style="{background: colors.hex8}">User3</span>
                </div>
            </li>
        </ul>
        <div class="set">
          <h3>名前のカラー選択</h3>
          <div class="radio-main">
            <chrome-picker :value="colors" v-model="colors"></chrome-picker>
          </div>
          <h3>コピペ用CSS</h3>
          <p>DiscordオーバレイのカスタムCSSです。</p>
          <p><a href="https://streamkit.discord.com/overlay" target="_blank" rel="noopener noreferrer">streamkit</a>でDiscordのボイスチャンネルのURLを取得→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
          <p><a href="https://www.ruri.info/?p=188" target="_blank" rel="noopener noreferrer">さらに詳しい使い方はこちら</a></p>
          <div class="radio-main">
            <textarea id="target" readonly class="discord-form-text" v-model="resultCSS" />
            <button @click="copy" class="copy-btn">コピー</button>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import {Chrome} from 'vue-color'
export default {
  name: "app",
  components: {
    'chrome-picker': Chrome,
   },
  data() {
    return {
      imgPath: require('@/assets/discord-icon.png'),
      colors: {
          hex: '#000000',
          hex8: '#000000FF',
          hsl: { h: 150, s: 0, l: 0, a: 1 },
          rgba: { r: 0, g: 0, b: 0, a: 1 },
          a: 1
      },
      importcss:':root {\n',
      namecolor:'--name-bg-color:',
    };
  },
  methods: {
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText("[class*='Voice_voiceStates__']{list-style-type:none;padding-left:15px;display:flex;flex-wrap:wrap;}[class*='Voice_voiceState__']{height:96px;}[class*='Voice_avatar__']{width:96px;height:96px;border-radius:12px;filter:brightness(90%);transition:filter 0.2s ease;margin-top:18px;margin-right: 18px;margin-bottom:3px;outline:0.13rem solid var(--name-bg-color)!important;border:none;box-shadow:4px 4px 0px 0 var(--name-bg-color);}[class*='Voice_avatarSpeaking__']{animation:var(--speaking-anime);filter:brightness(100%)!important;border:none!important;}[class*='Voice_name__']{text-align:center;width:96px;background-color:var(--name-bg-color)!important;opacity:var(--name-opacity)!important;font-size:12px!important;border-radius:6px;padding:1px 0px!important;margin-right:2px;margin-left:2px;margin-top:105px;box-sizing:border-box;overflow:hidden;display:block;}ul li{margin-top:30px;display:block;}[class*='Voice_name__']{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}\n" +this.importcss + this.namecolor + this.colors.hex8 + ";}\n")
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
  },
  watch:{
    namestyle:function(){
        this.setNameCss()
    },
  },
  computed: {
    resultCSS(){
        return "[class*='Voice_voiceStates__']{list-style-type:none;padding-left:15px;display:flex;flex-wrap:wrap;}[class*='Voice_voiceState__']{height:96px;}[class*='Voice_avatar__']{width:96px;height:96px;border-radius:12px;filter:brightness(90%);transition:filter 0.2s ease;margin-top:18px;margin-right: 18px;margin-bottom:3px;outline:0.13rem solid var(--name-bg-color)!important;border:none;box-shadow:4px 4px 0px 0 var(--name-bg-color);}[class*='Voice_avatarSpeaking__']{animation:var(--speaking-anime);filter:brightness(100%)!important;border:none!important;}[class*='Voice_name__']{text-align:center;width:96px;background-color:var(--name-bg-color)!important;opacity:var(--name-opacity)!important;font-size:12px!important;border-radius:6px;padding:1px 0px!important;margin-right:2px;margin-left:2px;margin-top:105px;box-sizing:border-box;overflow:hidden;display:block;}ul li{margin-top:30px;display:block;}[class*='Voice_name__']{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}\n" +this.importcss + this.namecolor + this.colors.hex8 + ";}\n";
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

.main{
  max-width: 767px;
  margin: 0 auto;
}

.set{
  padding: 8px 12px 24px 12px;
  margin-top: 24px;
  background-color: #FFFEF9;
  border-radius: 10px;
}

/* プレビューエリア */
.preview{
    padding: 2px 12px;
}

.flex-containar-2{
    height: 120px;
    width:100%;
    display: flex;
}

.voice-state-2{
    list-style-type: none;
    padding-left: 15px;
    display: block;
    margin-bottom: 8px;
}

.img-2{
    width: 96px;
    height: 96px;
    border-radius: 12px;
    object-fit: scale-down;
    padding: 5px;
    box-sizing:border-box;

    outline: 0.13rem solid;
    box-shadow: 4px 4px 0px 0 black;
}

.color1{
  background-color: blue;
}

.color2{
  background-color: lightcoral;
}

.color3{
  background-color: lightgreen;
}

.name-box-2{
    margin: 8px 0 0 0;
    color:white;
    width:96px;
    display: block;
    text-align: center;
}

.name-2{
    padding: 4px 12px;
    color:white;
    font-size:12px;
    border-radius: 6px;
    display: block;
    margin: 0 4px 0 4px;
}






.radio-main{
  display: -webkit-flex;
  display: flex;
  margin-top:12px;
}

.radio-main label{
  margin-right: 8px;
}

.discord-form-text{
    width: 60%;
  height: 80px;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.copy-btn{
  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}

.copy-btn:active{
  -webkit-transform: translateY(4px);
  transform: translateY(4px);
  border-bottom: none;
}

</style>